import { render, staticRenderFns } from "./New.vue?vue&type=template&id=16d8467d&scoped=true&"
import script from "./New.js?vue&type=script&lang=js&"
export * from "./New.js?vue&type=script&lang=js&"
import style0 from "./New.vue?vue&type=style&index=0&id=16d8467d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d8467d",
  null
  
)

export default component.exports